import { react2angular } from 'react2angular';
import BrokeragePDF from '../brokerage_pdf/BrokeragePdfComponent';
import EditAppointment from './EditAppointment';
import ExternalOffer from './ExternalOffer/ExternalOffer';
import ClientCalendarSyncButton from './ClientCalendarSyncButton';
import MyAgent from './MyAgent';
import ExternalNotification from './ExternalNotification';
import MobileMapsDrawer from './MobileMapsDrawer';

angular
  .module('bb.external', [
    'ngRoute',
    'bb.util',
    'bb.appointments',
    'bb.notifications',
    'bb.almanac',
    'bb.external.virtual_tour_details',
  ])
  .component('bbPrintPdf', react2angular(BrokeragePDF, [], ['$window']))
  .component(
    'bbExternalAppointmentDetails',
    react2angular(
      EditAppointment,
      [
        'appointment',
        'newStatus',
        'country',
        'isNewAppointment',
        'clearSelected',
        'serverDate',
        'updateAppointment',
        'isListingContact',
        'showFeedback',
      ],
      [
        '$q',
        '$route',
        '$routeParams',
        '$uibModal',
        '$location',
        '$rootScope',
        'AlmanacService',
        'ExternalAuth',
        'ExternalService',
        'ToastService',
      ],
    ),
  )
  .component(
    'bbExternalOffers',
    react2angular(
      ExternalOffer,
      [],
      [
        'ExternalAuth',
        'ExternalService',
        'ErrorService',
        '$routeParams',
        'listingNotificationSettings',
      ],
    ),
  )
  .component(
    'bbClientCalendarSyncButton',
    react2angular(
      ClientCalendarSyncButton,
      ['clientType'],
      ['$routeParams', '$location', '$window', 'ToastService'],
    ),
  )
  .component(
    'bbMyAgent',
    react2angular(MyAgent, [], ['ExternalAuth', 'ErrorService']),
  )
  .component(
    'bbExternalNotification',
    react2angular(ExternalNotification, [], ['ExternalAuth']),
  )
  .component(
    'bbMobileMapsDrawer',
    react2angular(
      MobileMapsDrawer,
      ['visible', 'setVisible', 'destinationAddress'],
      [],
    ),
  );

require('./auth.service');
require('./external.service');

require('./VirtualTourDetails/virtual_tour_details.module');

require('./external_feedback/external_feedback_question.component');
require('./external_feedback.component');
require('./appointment_list_coop.component');
require('./external_appointment_list.component');
require('./external_buyer_contact_appointment_list');
require('./appointment_list_view.component');
require('./appointment_updates.component');
require('./external_listing.component');
require('./view_listing.component');
require('./external_book.component');
require('./external_appointment_cancel.component');
require('./external_appointment_time_change.component');
require('./external_status_change.component');
require('./appointment_pdf_component');
require('./appointment_pdf');
require('./convo_pdf_component');
require('./convo_pdf');
require('./external.routes');
